import { routedClient } from "react-migration/lib/persistence/apollo/routedClient";
import { useUpdateSitesMutation as useUpdateSitesMutationGL } from "@gql/li-api/graphql";

export const useUpdateSitesMutation = () => {
  return useUpdateSitesMutationGL({ client: routedClient });
};
